const indexPath = [
"/properties/for-rent/in-dubai-marina/type-apartment/",  
"/properties/for-rent/in-dubai/type-townhouse/",  
"/properties/for-sale/in-dubai-marina/",  
"/properties/for-sale/in-palm-jumeirah/type-apartment/",  
"/properties/for-sale/in-jumeirah-beach-residence/type-apartment/",  
"/properties/for-rent/in-dubai/",  
"/properties/for-sale/in-palm-jumeirah/",  
"/properties/for-rent/in-palm-jumeirah/type-apartment/"];

export default indexPath;